// src/pages/AttendanceEntry/index.js
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, App, Button, Typography, Tooltip, Drawer, Flex, Grid} from "antd";
import { PrinterOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { resetAttendance } from "./attendanceEntrySlice";
import AttendanceFilters from "./components/AttendanceFilters";
import AttendanceTable from "./components/AttendanceTable";
import { useReactToPrint } from "react-to-print";
import ReportDom from "../../components/common/ReportDom";

const { Title } = Typography;

const AttendanceEntry = () => {
  const dispatch = useDispatch();

  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const { filters } = useSelector((state) => state.attendance);

  const reportRef = useRef();
  const [helpOpen, setHelpOpen] = useState(false);

  useEffect(() => {
    dispatch(resetAttendance());
  }, [dispatch]);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Attendance Entry",
    removeAfterPrint: true,
  });
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }}>
              Attendance
            </Title>
          }
          extra={
            <Flex align="center" gap={6}>
              <Tooltip title="Help">
                <Button
                  type="text"
                  icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                  onClick={() => setHelpOpen(true)}
                />
              </Tooltip>

              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={handlePrint}
              >
                Print
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <AttendanceFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <AttendanceTable />
        </Card>
      </App>
      <Drawer
        title="Attendance Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={430}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}

      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: 18,
              fontWeight: 600,
              marginBottom: 12,
              marginLeft: 12
            }}
          >
            Attendance Management
          </h2>

          <p style={{ color: "#555", marginBottom: 16, marginLeft: 17 }}>
            This section helps manage employee attendance records,
            attendance tracking, daily work status, and attendance reporting workflows.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: 14,
              borderRadius: 8,
              marginBottom: 16,
            }}
          >
            <strong>What You Can Do</strong>

            <ol style={{ paddingLeft: 20, marginTop: 10 }}>
              <li>View daily employee attendance records</li>
              <li>Filter attendance using selected criteria</li>
              <li>Track present and absent employees</li>
              <li>Monitor employee attendance activities</li>
              <li>Generate printable attendance reports</li>
              <li>Review attendance entries efficiently</li>
              <li>Manage attendance workflow operations</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: 14,
              borderRadius: 8,
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: 18,
                marginTop: 10,
                color: "#666",
              }}
            >
              <li>Attendance reports can be printed for operational use.</li>
              <li>Filters help quickly locate attendance records.</li>
              <li>Attendance data supports HR & Payroll workflows.</li>
              <li>Only authorized users can manage attendance records.</li>
            </ul>
          </div>
        </div>
      </Drawer>
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Attendance Entry"
          filters={filters}
          renderTable={() => (
            <AttendanceTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default AttendanceEntry;
